import styled from 'styled-components'
import { blue, red, textMuted, white } from '@/theme/colors'
import { shadows, radii, motion } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 20px;
	flex-wrap: wrap;
`

export { SearchInput } from '../adminList.styles'

export const TableWrap = styled.div`
	background-color: ${white};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.inner};
	overflow-x: auto;
`

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	font-size: ${fontSizes.base};
`

export const Th = styled.th`
	text-align: left;
	padding: 14px 16px;
	font-weight: 700;
	color: ${textMuted};
	border-bottom: 1px solid ${textMuted}22;
	white-space: nowrap;
`

export const Td = styled.td`
	padding: 12px 16px;
	border-bottom: 1px solid ${textMuted}14;
	color: ${blue};
	white-space: nowrap;
`

export const Row = styled.tr<{ $deleted?: boolean }>`
	cursor: pointer;
	background-color: ${({ $deleted }) => ($deleted ? `${red}10` : 'transparent')};
	transition: background-color ${motion.fast};

	&:hover {
		background-color: ${({ $deleted }) => ($deleted ? `${red}1f` : `${blue}0d`)};
	}

	&:last-child td {
		border-bottom: none;
	}
`

export const DeletedTag = styled.span`
	display: inline-block;
	margin-left: 8px;
	padding: 2px 8px;
	border-radius: ${radii.small};
	background-color: ${red};
	color: ${white};
	font-size: ${fontSizes.micro};
	font-weight: 700;
	vertical-align: middle;
`

export const InternalTag = styled.span`
	display: inline-block;
	margin-left: 8px;
	padding: 2px 8px;
	border-radius: ${radii.small};
	background-color: ${blue};
	color: ${white};
	font-size: ${fontSizes.micro};
	font-weight: 700;
	vertical-align: middle;
`

export const Pagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 16px;
	margin-top: 20px;
`

export const PageButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })``

export const PageStatus = styled.span`
	color: ${textMuted};
	font-size: ${fontSizes.small};
`


